import type { FC } from 'react'
import type { Allergens } from '@/types'

import { cn } from '@/lib/utils'

export const ALLERGENS: Array<{ key: keyof Allergens, letter: string, name: string }> = [
    { key: 'gluten', letter: 'گ', name: 'گلوتن' },
    { key: 'dairy', letter: 'ل', name: 'لبنیات' },
    { key: 'nuts', letter: 'م', name: 'مغزها' },
    { key: 'egg', letter: 'ت', name: 'تخم‌مرغ' }
]

interface AllergenMarkersProps {
    allergens: Allergens
    vegan?: boolean
    className?: string
}

export const AllergenMarker: FC<{ letter: string, name: string }> = ({ letter, name }) => (
    <span className='inline-flex size-5 items-center justify-center rounded-full border border-foreground/30 text-[0.6875rem] leading-none font-semibold text-foreground' title={`حاوی ${name}`}>
        <span aria-hidden='true'>{letter}</span>
        <span className='sr-only'>{name}</span>
    </span>
)

// Small lettered circles for what an item contains, plus a vegan mark.
export const AllergenMarkers: FC<AllergenMarkersProps> = ({ allergens, vegan = false, className }) => {
    const contained = ALLERGENS.filter(entry => allergens[entry.key])

    if (contained.length === 0 && !vegan) return null

    return (
        <span className={cn('inline-flex flex-wrap items-center gap-1', className)}>
            {contained.length > 0 && <span className='sr-only'>حاوی:</span>}

            {contained.map(entry => (
                <AllergenMarker key={entry.key} letter={entry.letter} name={entry.name} />
            ))}

            {vegan && (
                <span className='ms-1 inline-flex h-5 items-center rounded-full bg-flour-deep px-2 text-[0.6875rem] leading-none font-medium tracking-[0.14em] text-crust-soft uppercase'>
                    گیاهی
                </span>
            )}
        </span>
    )
}
